import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import _ from 'underscore'
const joinRedPackage = (data) => {
    return new Promise( (resolve, reject)=> {

        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)

        Api.post(url ,data,{
            headers: {
              'X-Host':'mall.asset.lucky-money.join-increment-active',
              'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getLuckyMoneyDetail = (data) => {
    return new Promise( (resolve, reject)=> {
        
        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`
        
        Api.get(url ,{
            headers: {
                'X-Host':'mall.asset.lucky-money.detail',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}
const getLuckyMoneyRecord = (data) => {
    return new Promise( (resolve, reject)=> {
        
        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST
        
        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.asset.lucky-money.increment-history',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, 
        (e)=> {
            reject(e)
        })
    })
}
/*yeoman-template-point-1*/
export default {
    joinRedPackage,
        getLuckyMoneyDetail,
    getLuckyMoneyRecord,
/*yeoman-template-point-2*/
}
